import * as R from 'ramda';
import { offsetTimezone } from '@trs/utils';
import { toBinary } from '@trs/utils/lib/strings';
import { propNames } from '../api/baseValues';

const { country, employeeType, annualSalary, currency, exchangeSource } = propNames;
const IS_DATETIME_TYPE = 'datetime';

const createModels = (mainState, instancesReducer) => {
  const { countries } = mainState;
  const { instanceFields } = instancesReducer;
  const models = {
    employees: [],
  };
  Object.keys(instanceFields).forEach((instanceKey) => {
    const fields = instanceFields[instanceKey];
    const employeeModel = {
      annualSalary: 0,
      employee: {},
      currencyDetails: {},
      employeeCurrency: R.path(['instances', instanceKey, 'defaultCurrency'], instancesReducer),
    };
    R.forEach((key) => {
      const { value: fieldValue, propertyName } = R.prop(key, fields);
      switch (propertyName) {
        case country: {
          const index = R.findIndex(R.propEq('value', fieldValue))(countries);
          employeeModel.employee.Country = fieldValue;
          employeeModel.employee.Currency = R.path([index, 'defaultCurrency'], countries);
          break;
        }
        case employeeType: {
          employeeModel.employee[propertyName] = fieldValue;
          break;
        }
        case annualSalary: {
          employeeModel.annualSalary = fieldValue;
          employeeModel.employee[propertyName] = fieldValue;
          break;
        }
        case currency: {
          employeeModel.currencyDetails.currencyCode = fieldValue;
          break;
        }
        case exchangeSource: {
          employeeModel.currencyDetails.fxSourceId = fieldValue;
          break;
        }
        default:
          employeeModel.employee[propertyName] =
            R.path([key, 'type'], fields) === IS_DATETIME_TYPE
              ? offsetTimezone(fieldValue)
              : fieldValue;
          break;
      }
    }, R.keys(fields));

    R.forEach((key) => {
      employeeModel.employee[key] =
        typeof employeeModel.employee[key] === 'string'
          ? toBinary(employeeModel.employee[key])
          : toBinary(employeeModel.employee[key].toString());
    }, R.keys(employeeModel.employee));

    models.employees.push(employeeModel);
  });

  return models;
};

export default createModels;
